export const getUrlSearchParams = () => {
  return new URLSearchParams(window.location.search)
}
